import { Helmet } from "react-helmet-async"
import { IHotel } from "../../../../../Hotels"
import { HotelPayments } from "../../../../../Hotels/Item"
import { useOutletContext } from "../../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../../Auth"

export default function HotelPaymentsPage() {
	const { hotel } = useOutletContext<{ hotel: IHotel }>()
	return (
		<>
			<Helmet>
				<title>Payments | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized
				anyPermissions={[
					PERMISSIONS.VIEW_HOTEL_BOOKINGS,
					PERMISSIONS.MANAGE_ACCOUNTING,
				]}
			>
				<HotelPayments paymentType="debit" hotel={hotel} />
			</ForbidUnlessAuthorized>
		</>
	)
}
